module.exports = __webpack_public_path__ + "img/login_left.ed3fd3f4.png";